import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { CircularProgress, Snackbar, Alert, Switch, Modal, Fade, Button } from "@mui/material";
import MeasurementEditForm from "./MeasurmentEditForm";
import {
  fetchInventoryByCategory,
  fetchInventoryFabric,
  getProductTypesAction,
} from "../../redux/actions/orderActions";
import ConfirmationModal from "./Reusables/ConfirmationModal";
import { deleteMeasurement } from "../../redux/actions/measurementActions";
import { formatLabel } from "./Reusables/formatlabel";

const QuotationForm = () => {
  const { dealerInfo } = useSelector((state) => state.dealerLogin);
  const { productTypes } = useSelector((state) => state.productTypes);
  const inventoryByCategory = useSelector((state) => state.inventoryByCategory);
  const { loading: IBCLoading, error, inventory } = inventoryByCategory;
  const { fabrics, loading: fabricsLoading, error: FabricsError } = useSelector(
    (state) => state.inventoryFabrics
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [measurements, setMeasurements] = useState({});
  const [totalSqft, setTotalSqft] = useState(0);
  const [formValues, setFormValues] = useState({
    clientName: "",
    clientEmail: "",
    clientPhone: "",
    clientAddress: "",
    orderStatus: "draft",
    quotedPrice: "",
    productType: "",
    tag: "",
  });
  const [actionType, setActionType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [showClientDetails, setShowClientDetails] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    const fetchMeasurements = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_DP_API}/api/dealer-portal/measurement/${id}`,
          {
            headers: {
              Authorization: `Bearer ${dealerInfo.token}`,
            },
          }
        );
        const data = response.data;
        setMeasurements(data);
        setFormValues({
          clientName: data.clientName || "",
          clientEmail: data.clientEmail || "",
          clientPhone: data.clientPhone || "",
          clientAddress: data.clientAddress || "",
          orderStatus: data.orderStatus || "quoted",
          quotedPrice: data.quotedPrice || "",
          productType: data.productType || "",
          tag: data.tag || "",
        });
        setTotalSqft(data.totalSqft || 0);
      } catch (error) {
        console.error("Error fetching measurements:", error);
        setAlertMessage("Error fetching measurement data");
        setAlertType("error");
        setOpenSnackbar(true);
      }
    };

    fetchMeasurements();
  }, [dealerInfo.token, id]);

  useEffect(() => {
    if (formValues?.productType) {
      dispatch(fetchInventoryByCategory(formValues?.productType, dealerInfo.token));
      dispatch(fetchInventoryFabric(formValues?.productType, dealerInfo.token));
    }
  }, [dispatch, formValues.productType, dealerInfo.token]);

  useEffect(() => {
    if (dealerInfo?.token) {
      dispatch(getProductTypesAction(dealerInfo.token));
    }
  }, [dispatch, dealerInfo]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const dataToSend = {
        ...formValues,
      };
      const response = await axios.put(
        `${process.env.REACT_APP_DP_API}/api/dealer-portal/measurement/${id}`,
        dataToSend,
        {
          headers: {
            Authorization: `Bearer ${dealerInfo.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setAlertMessage("Measurement updated successfully!");
      setAlertType("success");
      navigate("/order/measurements");
    } catch (error) {
      setAlertMessage("Error updating measurement. Please try again.");
      setAlertType("error");
    } finally {
      setLoading(false);
      setOpenSnackbar(true);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleSaveMeasurement = () => {
    setActionType("save");
    setFormValues((prevValues) => ({
      ...prevValues,
      orderStatus: "quoted",
    }));
    handleSubmit();
  };

  const handleSendToManufacturer = () => {
    setActionType("send");
    setOpenConfirmationModal(true);
    setFormValues((prevValues) => ({
      ...prevValues,
      orderStatus: "confirmed",
    }));
  };

  const handleConfirmation = () => {
    handleSubmit();
    setOpenConfirmationModal(false);
  };

  const handleDeleteMeasurement = () => {
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    dispatch(deleteMeasurement(id));
    setShowDeleteModal(false);
    navigate("/order/measurements");
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
  };

  return (
    <div className="card w-100 mx-auto">
      <div className="card-header d-flex align-items-center justify-content-between">
        <span
          className="badge"
          style={{
            backgroundColor: "#f5c600",
            color: "#fff",
            fontWeight: "bold",
            padding: "8px 16px",
            borderRadius: "16px",
            fontSize: "15px",
          }}
        >
          Request a Quote
        </span>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-primary dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Actions
          </button>
          <ul className="dropdown-menu">
            <li>
              <button
                className="dropdown-item text-primary"
                onClick={handleSaveMeasurement}
              >
                <i className="bi bi-save me-2"></i> Save Measurement
              </button>
            </li>
            <li>
              <button
                className="dropdown-item text-success"
                onClick={handleSendToManufacturer}
              >
                <i className="bi bi-truck me-2"></i> Send to Manufacturer
              </button>
            </li>
            <li>
              <button
                className="dropdown-item text-danger"
                onClick={handleDeleteMeasurement}
              >
                <i className="bi bi-trash me-2"></i> Delete Measurement
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="card-body">
        <form className="row g-3" onSubmit={handleSubmit}>
          <div className="col-12">
            <div className="d-flex align-items-center">
              <Switch
                checked={showClientDetails}
                onChange={() => setShowClientDetails(!showClientDetails)}
              />
              <span>Show Client Details</span>
            </div>
          </div>
          {showClientDetails && (
            <div className="col-md-6 mb-3">
              <div className="form-group mb-2">
                <label htmlFor="client-name">Client Name</label>
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="bi bi-person"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    id="client-name"
                    name="clientName"
                    value={formValues.clientName}
                    onChange={handleInputChange}
                    placeholder="John Doe"
                  />
                </div>
              </div>
              <div className="form-group mb-2">
                <label htmlFor="client-email">Client Email</label>
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="bi bi-envelope"></i>
                  </span>
                  <input
                    type="email"
                    className="form-control"
                    id="client-email"
                    name="clientEmail"
                    value={formValues.clientEmail}
                    onChange={handleInputChange}
                    placeholder="john@example.com"
                  />
                </div>
              </div>
              <div className="form-group mb-2">
                <label htmlFor="client-phone">Client Phone</label>
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="bi bi-phone"></i>
                  </span>
                  <input
                    type="tel"
                    className="form-control"
                    id="client-phone"
                    name="clientPhone"
                    value={formValues.clientPhone}
                    onChange={handleInputChange}
                    placeholder="(123) 456-7890"
                  />
                </div>
              </div>
              <div className="form-group mb-2">
                <label htmlFor="client-address">Client Address</label>
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="bi bi-house-door"></i>
                  </span>
                  <textarea
                    className="form-control"
                    id="client-address"
                    name="clientAddress"
                    rows={3}
                    value={formValues.clientAddress}
                    onChange={handleInputChange}
                    placeholder="123 Main St, Anytown USA"
                  ></textarea>
                </div>
              </div>
            </div>
          )}
          <div className="col-md-6">
            <div className="form-group mb-2">
              <label htmlFor="order-status">Order Status</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-clipboard-check"></i>
                </span>
                <select
                  className="form-select"
                  id="order-status"
                  name="orderStatus"
                  value={formValues.orderStatus}
                  onChange={handleInputChange}
                >
                  <option value="measured">Measured</option>
                  <option value="quoted">Quoted</option>
                  <option value="confirmed">Confirmed</option>
                  <option value="draft">Draft</option>
                </select>
              </div>
            </div>
            <div className="form-group mb-2">
              <label htmlFor="quoted-price">Quoted Price</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-currency-dollar"></i>
                </span>
                <input
                  type="number"
                  className="form-control"
                  id="quoted-price"
                  name="quotedPrice"
                  value={formValues.quotedPrice}
                  onChange={handleInputChange}
                  placeholder="Enter quoted price"
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-4">
                <label className="form-label">Product Type</label>
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="bi bi-box"></i>
                  </span>
                  <select
                    className="form-select"
                    id="product-type"
                    name="productType"
                    value={formValues.productType}
                    onChange={handleInputChange}
                  >
                    <option value=""></option>
                    {productTypes.map((option) => (
                      <option key={option._id} value={option.name}>
                        {formatLabel(option.name)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-lg-4">
                <label className="form-label">Tags</label>
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="bi bi-tag"></i>
                  </span>
                  <input
                    type="text"
                    name="tag"
                    className="form-control"
                    value={formValues.tag || ""}
                    onChange={handleInputChange}
                    placeholder="Add tags"
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
        <MeasurementEditForm productType={formValues.productType} fabrics={fabrics} />
      </div>
      {openConfirmationModal && (
        <ConfirmationModal
          openConfirmationModal={openConfirmationModal}
          setOpenConfirmationModal={setOpenConfirmationModal}
          handleConfirmation={handleConfirmation}
        />
      )}
      <Modal
        open={showDeleteModal}
        onClose={handleCancelDelete}
        closeAfterTransition
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Fade in={showDeleteModal}>
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
              maxWidth: "500px",
              width: "100%",
            }}
          >
            <div className="modal-header">
              <h5 className="modal-title">Confirm Deletion</h5>
              <button
                type="button"
                className="close"
                onClick={handleCancelDelete}
              >
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this measurement?</p>
            </div>
            <div className="modal-footer">
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleCancelDelete}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={handleConfirmDelete}
              >
                Delete
              </Button>
            </div>
          </div>
        </Fade>
      </Modal>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity={alertType}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default QuotationForm;